import { Outlet, createFileRoute, useRouterState } from "@tanstack/react-router";

import { PermissionGuard } from "~/components/permission-guard";
import { oasisPermissionForAiEditsPath } from "~/modules/agave-evals/permission";
import { ensureSession } from "~/modules/auth/credentials";

export const Route = createFileRoute("/_dash/ai-edits")({
  component: AiEditsRoute,
  beforeLoad() {
    ensureSession();
  },
});

function AiEditsRoute() {
  const permission = useRouterState({
    select: (state) => oasisPermissionForAiEditsPath(state.location.pathname),
  });

  return (
    <PermissionGuard permission={permission}>
      <Outlet />
    </PermissionGuard>
  );
}
